import engineering from '../../assets/images/career/engineering.png';
import life_science from '../../assets/images/career/life_science.png';
import medical_sc from '../../assets/images/career/medical_sc.png';
import physical_sc from '../../assets/images/career/physical_sc.png';
import environmental_sc from '../../assets/images/career/environmental_sc.png';
import architecture from '../../assets/images/career/architecture.png';
import finance from '../../assets/images/career/finance.png';
import business_mng from '../../assets/images/career/business_mng.png';
import hospitality from '../../assets/images/career/hospitality.png';
import fine_arts from '../../assets/images/career/fine_arts.png';
import designing from '../../assets/images/career/designing.png';
import law from '../../assets/images/career/law.png';
import performing_arts from '../../assets/images/career/performing_arts.png';
import media from '../../assets/images/career/media.png';
import social_sc from '../../assets/images/career/social_sc.png';

export const careerImages={
     careerOption1: engineering,
     careerOption2:life_science,
     careerOption3:medical_sc,
     careerOption4:physical_sc,
     careerOption5 :environmental_sc,
     careerOption6 :architecture,
     careerOption7 :finance,
     careerOption8 :business_mng,
     careerOption9 :hospitality,
     careerOption10 :fine_arts,
     careerOption11 :designing,
     careerOption12 :law,
     careerOption13 :performing_arts,
     careerOption14 :media,
     careerOption15 :social_sc,

    }

export const CollegeSrc =
[
  {
    'title': 'Data Science',
    'position_title': 'A Data Scientist',
    'desc':
        'A data scientist is a professional who is skilled in extracting insights and knowledge from large volumes of data.',
    'image': careerImages.careerOption1,
    },
  {
    'title': 'Medical Science',
    'position_title': 'An Anatomist',
    'desc':
        'An anatomist is a professional who studies the structure of organisms, primarily focusing on the arrangement of body parts and their relationships to one another.',
    'image': careerImages.careerOption2,
     },
  {
    'title': 'Public Administration / Govt Jobs',
    'position_title': 'A Public administrator',
    'desc':
        'Public administrators are responsible for managing and implementing public policies, programs, and services on behalf of government agencies at various levels.',
    'image': careerImages.careerOption3,

  },
  {
    'title': 'Media & Communication',
    'position_title': 'A Journalist',
    'desc':
        'A journalist is a professional who gathers, analyzes, and disseminates news and information to the public through various media channels.',
    'image': careerImages.careerOption4,
  
  },
  {
    'title': 'Ethical Hacking / Information Security',
    'position_title': 'A Hacker',
    'desc':
        'Cybersecurity professionals work to ensure the confidentiality, integrity, and availability of information in the digital space.',
    'image': careerImages.careerOption5,

  },
  {
    'title': 'M. Tech',
    'position_title': 'M.Tech Graduate',
    'desc':
        'M.Tech is a postgraduate program that provides advanced training in various engineering disciplines',
    'image': careerImages.careerOption6,
 
  },
  {
    'title': 'Environmental Science',
    'position_title': 'An Environmental Scientist',
    'desc':
        'An environmental scientist is a professional who studies the natural environment and works to address environmental issues',
    'image': careerImages.careerOption7,
 
  },
  {
    'title': 'Financial Management',
    'position_title': 'A Financial Advisor ',
    'desc':
        'Financial management is a critical aspect of business and organizational operations that involves planning, organizing, directing, and controlling financial resources',
    'image': careerImages.careerOption8,
  
  },
  {
    'title': 'Entrepreneurship',
    'position_title': 'An Entrepreneur',
    'desc':
        'An entrepreneur is an individual who takes on the responsibility of starting and managing a business, typically with the aim of earning a profit',
    'image': careerImages.careerOption9,
   
  },
  {
    'title': 'Interior Design',
    'position_title': 'An Interior Designer',
    'desc':
        'An interior designer is a professional who specializes in creating aesthetically pleasing and functional interior spaces',
    'image': careerImages.careerOption10,
 
  },
  {
    'title': 'Designing',
    'position_title': 'A Designer',
    'desc':
        'The term "designer" is broad and can apply to professionals across various fields who specialize in creating and planning visual or functional solutions',
    'image': careerImages.careerOption11,
 
  },
  {
    'title': 'Non-profit / Social Services',
    'position_title': 'Neelam Shaikh',
    'desc':
        'Social science entails the study of human behavior and society at a variety of levels. Popular social science majors include psychology, political science, and economics........',
    'image': careerImages.careerOption12,

  },
  {
    'title': 'Visual Arts',
    'position_title': 'A Visual Artist',
    'desc':
        'A visual artist is an individual who creates visual art, which is a form of artistic expression that can encompass a wide range of mediums and styles',
    'image': careerImages.careerOption13,
 
  },
  {
    'title': 'Performing Arts',
    'position_title': 'A Performer',
    'desc':
        'A performer is an individual who entertains an audience through various forms of artistic expression, often involving live presentations, demonstrations, or productions',
    'image': careerImages.careerOption14,
  
  },
  {
    'title': 'Sustainability Management',
    'position_title': 'A Sustainability Manager',
    'desc':
        'Sustainability management refers to the strategic planning, coordination, and implementation of practices that promote sustainability within an organization',
    'image': careerImages.careerOption15,
   
  },
  {
    'title': 'Human Resource Management',
    'position_title': 'A HR Manager',
    'desc':
        'A Human Resources (HR) Manager is a professional responsible for overseeing the human resources function within an organization',
    'image': careerImages.careerOption1,
  
  },
  {
    'title': 'Teaching',
    'position_title': 'A Teacher',
    'desc':
        'A professor or lecturer in many academic systems, is an educator who specializes in teaching at the post-secondary or tertiary level',
    'image': careerImages.careerOption2,
  },
  {
    'title': 'Fashion Design',
    'position_title': 'A Fashion Designer',
    'desc':
        'A fashion designer is a creative professional who specializes in designing clothing, accessories, and footwear.',
    'image': careerImages.careerOption2,
  },
  {
    'title': 'Testing / Full stack Development',
    'position_title': 'A Tester',
    'desc':
        "It seems like your message is a bit brief, and I'm not sure if you're referring to a software tester or another type of tester",
    'image': careerImages.careerOption2,
  },
  {
    'title': 'Agriculture',
    'position_title': 'An Agricultural Manager',
    'desc':
        'Agriculture is a broad field that involves the cultivation of crops, raising animals, and various practices related to food production',
    'image': careerImages.careerOption3,
  },
  {
    'title': 'Graphic Design',
    'position_title': 'A Graphic Designer',
    'desc':
        'A graphic designer is a professional who specializes in creating visual content for various mediums, such as print, digital, and social media',
    'image': careerImages.careerOption4,
  },
  {
    'title': 'Psychology',
    'position_title': 'A psychologist',
    'desc':
        'A psychologist is a professional who studies human behavior and mental processes, aiming to understand, explain, and apply knowledge about various aspects of human experience',
    'image': careerImages.careerOption5,
  },
  {
    'title': 'Animation',
    'position_title': 'An Animator',
    'desc':
        'An animator is a creative professional who specializes in bringing visual elements to life through the use of animation techniques',
    'image': careerImages.careerOption6,
  },
  {
    'title': 'CA/CS',
    'position_title': 'A Chartered Accountant',
    'desc':
        ' Chartered Accountant (CA) is a professional accountant who has earned the Chartered Accountant designation through education, training, and practical experience',
    'image': careerImages.careerOption7,
  },
  {
    'title': 'Architecture',
    'position_title': 'An Architect',
    'desc':
        'Architecture is the art & science of designing & engineering large structures & buildings.',
    'image': careerImages.careerOption8,
  },
  {
    'title': 'Hospitality',
    'position_title': 'A ',
    'desc':
        'Hospitality deals with the applying management principles in the field of hospitality.',
    'image': careerImages.careerOption9,

  },
];


export const SchoolSrc=[
  {
    'title': 'Engineering',
    'position_title': 'An Engineer',
    'desc':
        'An Engineer, or Senior Engineer, uses math and science to solve different technical problems',
    'image': careerImages.careerOption1,
  },
  {
    'title': 'Life Science',
    'position_title': 'A Bacteriologist',
    'desc':
        'Life science refers to the study of living organisms including, microbes, humans, plants, etc.',
    'image': careerImages.careerOption2,
  },
  {
    'title': 'Medical Science',
    'position_title': 'A Antomist',
    'desc': 'Medical science covers many subjects which try to explain how the human body works.',
    'image': careerImages.careerOption3,
  },
  {
    'title': 'Physical Science',
    'position_title': 'A Chemist',
    'desc':
        'Physical science is the study of the inorganic world. That is, it does not study living things.',
    'image': careerImages.careerOption4,
  },
  {
    'title': 'Environmental Science',
    'position_title': 'An Environmetal Engineer',
    'desc':
        'Environmental Science is about studying Earth systems to learn from past & influence future.',
    'image': careerImages.careerOption5,
  },
  {
    'title': 'Architecture',
    'position_title': 'An Architect Engineer',
    'desc':
        'Architecture is the art & science of designing & engineering large structures & buildings.',
    'image': careerImages.careerOption6,
  },
  {
    'title': 'Finance',
    'position_title': 'A Financial Analyst',
    'desc':
        'Finance is a broad term that describes activities associated with banking, debt, credit, etc.',
    'image': careerImages.careerOption7,
  },
  {
    'title': 'Business Management',
    'position_title': 'A Manager',
    'desc':
        'Business Management provides knowledge & training pertaining to all things related to business.',
    'image': careerImages.careerOption8,
  },
  {
    'title': 'Hospitality',
    'position_title': 'A Manager',
    'desc':
        'Hospitality deals with the applying management principles in the field of hospitality.',
    'image': careerImages.careerOption9,
  },
  {
    'title': 'Fine Arts',
    'position_title': 'A Art Connoisseur',
    'desc':
        'Fine Arts are the study of different art forms such as drawing, sculpture, painting, literature, etc.',
    'image': careerImages.careerOption10,
  },
  {
    'title': 'Designing',
    'position_title': 'A Designer',
    'desc':
        'A designer plays a key role in a company with skills like, illustration, photography, etc.',
    'image': careerImages.careerOption11,
  },
  {
    'title': 'Legislative Law',
    'position_title': 'A Lawyer',
    'desc': 'Law careers advocate for justice and shape society through legal expertise.',
    'image': careerImages.careerOption12,
  },
  {
    'title': 'Performing Arts',
    'position_title': 'A Performer',
    'desc':
        'This course provides education related to performance art like dance, drama and music.',
    'image': careerImages.careerOption13,
  },
  {
    'title': 'Media & Communication',
    'position_title': 'A Content Producer',
    'desc':
        'Media & Communication focuses on content production for print, television, radio & digital media.',
    'image': careerImages.careerOption14,
  },
  {
    'title': 'Social Science',
    'position_title': 'A Sociologist',
    'desc':
        'Social science entails the study of human behavior and society at a variety of levels.',
    'image': careerImages.careerOption15,
 
  },
  {
    'title': 'Physical Science',
    'position_title': 'A Physicist',
    'desc':
        'Physicists seek to understand the fundamental principles that govern the universe and use mathematical models and experiments to explore and explain physical phenomena',
    'image': careerImages.careerOption7,
 
  },
]